import React from "react";
import { motion } from "framer-motion";
import { pageTransition, pageSlide } from "../utils/styleUtils";
import ConfirmAddress from "../components/ConfirmAddress";

function PaymentScreen() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageSlide}
      transition={pageTransition}
    >
      <ConfirmAddress />
    </motion.div>
  );
}
export default PaymentScreen;
